import Vue from 'vue'
import App from './App.vue'
import router from './router'

Vue.config.productionTip = false

function setRootFontSize() {
  const doc = document.documentElement
  const width = doc.clientWidth || 375
  const designWidth = 375
  const baseFontSize = 16
  const raw = (width / designWidth) * baseFontSize
  const fontSize = Math.max(14, Math.min(raw, 20))
  doc.style.fontSize = fontSize + 'px'
}

setRootFontSize()
window.addEventListener('resize', setRootFontSize)
window.addEventListener('orientationchange', setRootFontSize)

function setViewportHeightVar() {
  const doc = document.documentElement
  const h = window.innerHeight || doc.clientHeight || 0
  doc.style.setProperty('--vh', (h * 0.01) + 'px')
}

setViewportHeightVar()
window.addEventListener('resize', setViewportHeightVar)
window.addEventListener('orientationchange', setViewportHeightVar)

new Vue({
  router,
  render: h => h(App)
}).$mount('#app')
